module.exports = __webpack_public_path__ + "static/media/goal.e6083c0b.png";